import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import SearchInput from 'components/form/SearchInput'
import classNames from 'classnames'
import MixedBasicPreview from 'features/creative/preview/MixedBasicPreview'
import api from 'api/axios/foka'
import { useConfirm } from 'features/dialog/Confirm'
import { useSelector } from 'react-redux'
import { Link, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import ad from 'api/axios/foka/ad'
import { fail, failWithErrorResponse, success } from 'features/toast/Toast'
import { fillCreativeEmptyLandingUrl } from 'features/creative/creativeUtil'
import {
  ASSET_COMBINATIONS,
  BizChannelTypes,
  DashboardTypes,
} from 'features/Codes'
import MixedCreativePreviewList from 'features/creative/preview/MixedCreativePreviewList'
import AssetPreview from 'features/creative/preview/AssetPreview'
import SelectCreativeItem from 'features/ad/creative/SelectCreativeItem'
import NoneAnchor from 'components/NoneAnchor'
import { DASHBOARD_REFERRER } from 'features/ad/useDashboardReferrer'
import MixedTalkChannelPreview from '../../creative/preview/MixedTalkChannelPreview'
import { noop } from 'lodash'

const SelectCreative = ({ referrer }) => {
  const [searchText, setSearchText] = useState()
  const [selectedCreative, selectCreative] = useState(null)
  const [searchResult, setSearchResult] = useState([])
  const [checkedCreativeIds, setCheckedCreativeIds] = useState([])
  const [CancelSelectConfirm, showCancelSelectConfirm] = useConfirm()
  const { accountId: adAccountId } = useParams()
  const { channel, creatives, creativeLinks } = useSelector(
    state => state.ad.groupCreative
  )
  const bizChannelType = useMemo(
    () =>
      channel ? channel.bizChannelType : BizChannelTypes.WEBSITE_BIZ_CHANNEL,
    [channel]
  )
  const history = useHistory()
  const { campaignId, adGroupId } = useParams()
  const { url } = useRouteMatch()

  useEffect(() => {
    setSearchResult(creatives)
  }, [creatives])

  const handleSelectCreative = id => async () => {
    await api.creative
      .getCreative(id)
      .then(({ data }) => {
        selectCreative(
          fillCreativeEmptyLandingUrl(data.creative, channel.siteUrl)
        )
      })
      .catch(noop)
  }
  const onSearchTextChange = ({ target: { value } }) => setSearchText(value)
  const handleSearch = () => {
    setSearchResult(
      creatives.filter(({ creativeName }) => creativeName.includes(searchText))
    )
  }
  const handleCheckCreative = creativeId => () => {
    if (checkedCreativeIds.includes(creativeId)) {
      setCheckedCreativeIds(checkedCreativeIds.filter(id => id !== creativeId))
    } else {
      setCheckedCreativeIds(checkedCreativeIds.concat([creativeId]))
    }
  }
  const handleSaveCreativeLink = async () => {
    if (checkedCreativeIds.length === 0) {
      fail('등록할 소재를 1개 이상 입력해야 합니다.')
      return
    }
    try {
      await ad.postCreativeLinks(adGroupId, checkedCreativeIds)
      success('선택된 소재가 저장되었습니다.')
      history.push(
        `/${adAccountId}/afterCreate?type=${DashboardTypes.CREATIVE}&campaignId=${campaignId}&adGroupId=${adGroupId}`
      )
    } catch (error) {
      failWithErrorResponse(error?.response?.data)
    }
  }

  const [isMobileView, setMobileView] = useState(true)
  const validCombinations = (
    isMobileView ? ASSET_COMBINATIONS.mobile : ASSET_COMBINATIONS.pc
  ).filter(comb =>
    selectedCreative
      ? comb.every(type =>
          selectedCreative.assets.find(asset => asset.type.name === type)
        )
      : false
  )

  return (
    <>
      <div className="material_detail add_material_existing">
        <div className="top_material">
          <div className="tit_material">
            <h3 className="subtit_subject">소재 등록</h3>
            <ul className="tap_complete">
              <li
                onClick={() =>
                  history.push(
                    `${url}/new${referrer ? `?from=${referrer}` : ''}`
                  )
                }>
                <NoneAnchor className="btn_complete">
                  <span className="inner_g">
                    <span className="ico_comm" />새 소재
                  </span>
                </NoneAnchor>
              </li>
              <li className="on">
                <NoneAnchor className="btn_complete">
                  <span className="inner_g">
                    <span className="ico_comm" />
                    기존 소재 사용하기
                  </span>
                </NoneAnchor>
              </li>
            </ul>
          </div>
        </div>
        <div className="cont_material">
          <div className="group_material">
            {creatives.length === 0 ? (
              <div className="info_none">
                <p className="desc_none">
                  등록된 광고소재가 없습니다.
                  <br />
                  <Link to={`${url}/new`} className="fc_emph">
                    새 소재
                  </Link>
                  를 클릭하여 소재를 등록하세요.
                </p>
              </div>
            ) : (
              <>
                <div className="box_material">
                  <div className="inner_material">
                    <strong className="tit_existing">
                      소재<em className="fc_emph"> {creatives.length}</em>
                    </strong>
                    <div className="search_complete">
                      <div className="inner_complete">
                        <SearchInput
                          placeholder="소재명을 검색하세요."
                          value={searchText}
                          onChange={onSearchTextChange}
                          onSearch={handleSearch}
                        />
                      </div>
                    </div>
                    <strong className="screen_out">기존 소재 목록</strong>
                    {searchResult.length === 0 ? (
                      <>검색결과가 없습니다.</>
                    ) : (
                      <ul className="list_adlist">
                        {searchResult.map(creative => (
                          <SelectCreativeItem
                            key={creative.id}
                            checked={
                              creativeLinks.includes(creative.id) ||
                              checkedCreativeIds.includes(creative.id)
                            }
                            onCheck={handleCheckCreative(creative.id)}
                            onClick={handleSelectCreative(creative.id)}
                            creative={creative}
                            disabled={creativeLinks.includes(creative.id)}
                          />
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="view_material">
                  {!selectedCreative ? (
                    <div className="view_none">
                      <p className="desc_none">
                        소재리스트 오버 시{' '}
                        <span className="fc_emph">미리보기</span> 버튼이
                        노출됩니다.
                        <br />
                        미리보기 버튼을 클릭하여 소재를 볼 수 있습니다.
                      </p>
                    </div>
                  ) : (
                    <>
                      <div className="view_tit">
                        <strong className="tit_view">미리보기</strong>
                        <ul className="tab_view">
                          {bizChannelType === BizChannelTypes.TALK_CHANNEL ? (
                            <li className="on">
                              <NoneAnchor className="link_tab">
                                모바일 전용
                              </NoneAnchor>
                            </li>
                          ) : (
                            <>
                              <li className={classNames({ on: isMobileView })}>
                                <NoneAnchor
                                  className="link_tab"
                                  onClick={() => setMobileView(true)}>
                                  모바일
                                </NoneAnchor>
                              </li>
                              <li className={classNames({ on: !isMobileView })}>
                                <NoneAnchor
                                  className="link_tab"
                                  onClick={() => setMobileView(false)}>
                                  PC
                                </NoneAnchor>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                      {bizChannelType === BizChannelTypes.TALK_CHANNEL ? (
                        <MixedTalkChannelPreview
                          channel={channel}
                          creative={selectedCreative}
                        />
                      ) : (
                        <>
                          <div
                            className={classNames('view_detail', {
                              view_mo: isMobileView,
                              view_pc: !isMobileView,
                            })}>
                            <em className="view_type">기본</em>
                            <MixedBasicPreview
                              creative={selectedCreative}
                              siteUrl={channel.siteUrl}
                              isMobileView={isMobileView}
                            />
                          </div>
                          {validCombinations.length > 0 && (
                            <MixedCreativePreviewList
                              combinations={validCombinations}
                              creative={selectedCreative}
                              siteUrl={channel.siteUrl}
                              isMobileView={isMobileView}
                            />
                          )}
                          {selectedCreative.assets.length > 0 && (
                            <AssetPreview
                              creative={selectedCreative}
                              isMobileView={isMobileView}
                            />
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="page_btn">
        <div className="inner_btn">
          <button
            type="button"
            className="btn_gm"
            onClick={() => showCancelSelectConfirm()}>
            <span className="inner_g">취소</span>
          </button>
          <button
            type="button"
            className="btn_gm gm_bl"
            onClick={handleSaveCreativeLink}
            disabled={setCheckedCreativeIds.length === 0}>
            <span className="inner_g">선택한 소재 사용</span>
          </button>
        </div>
      </div>
      <CancelSelectConfirm
        title="소재선택 취소"
        onClose={({ isConfirmed }) => {
          if (isConfirmed) {
            if (referrer && referrer !== DASHBOARD_REFERRER.CREATIVE) {
              history.push(
                `/${adAccountId}/afterCreate?type=${DashboardTypes.KEYWORD}&campaignId=${campaignId}&adGroupId=${adGroupId}`
              )
            } else {
              history.push(`/${adAccountId}/dashboard`)
            }
          }
        }}>
        <>
          소재선택을 취소하시겠습니까?
          <br />
          저장되지 않은 모든 내용은 사라집니다.
        </>
      </CancelSelectConfirm>
    </>
  )
}

export default SelectCreative

SelectCreative.propTypes = {
  referrer: PropTypes.string,
}
